export default [
	{
		path: '/health/base/:id/:type?',
		name: 'HealthBaseInfo',
		component: () => import('@/views/health/base.vue'),
		meta: { title: '基础信息' }
	},
	{
		path: '/health/medication/list/:id',
		name: 'HealthMedicationList',
		component: () => import('@/views/health/medication-list.vue'),
		meta: { title: '用药信息' }
	},
	{
		path: '/health/medication/:id?',
		name: 'HealthMedication',
		component: () => import('@/views/health/medication.vue'),
		meta: { title: '用药提醒' }
	},
	{
		path: '/health/medical/edit/:id',
		name: 'HealthMedicalEdit',
		component: () => import('@/views/health/medical/edit.vue'),
		meta: { title: '就医记录' }
	},
	{
		path: '/health/medical/list/:id',
		name: 'HealthMedicalList',
		component: () => import('@/views/health/medical/list.vue'),
		meta: { title: '就医记录' }
	},
	{
		path: '/health/inspection/edit/:id',
		name: 'HealthInspectionEdit',
		component: () => import('@/views/health/inspection/edit.vue'),
		meta: { title: '检验记录' }
	},
	{
		path: '/health/inspection/list/:id',
		name: 'HealthInspectionList',
		component: () => import('@/views/health/inspection/list.vue'),
		meta: { title: '检验记录' }
	},
	{
		path: '/health/physical/edit/:id',
		name: 'HealthPhysicalEdit',
		component: () => import('@/views/health/physical/edit.vue'),
		meta: { title: '体检记录' }
	},
	{
		path: '/health/physical/list/:id',
		name: 'HealthPhysicalList',
		component: () => import('@/views/health/physical/list.vue'),
		meta: { title: '体检记录' }
	}
]
